/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import _ from 'lodash';
import { getProxyUrl } from '../../utils/image';
import { getPlayerUrlById } from '../../utils/routes';
import { useLineup } from '../../hooks/matchdetails';
import Loader from '../Loader';

function Formation({ match, homeTeam }) {
  const team = homeTeam ? match?.homeTeamName : match?.visitingTeamName;
  const [lineups, lineupsLoading] = useLineup(
    match?.id,
    match?.configSeasonStartYear
  );

  const lineup = homeTeam
    ? lineups?.homeTeamLineup
    : lineups?.visitingTeamLineup;

  const renderFormationPlayer = (player) => {
    const playerUrl = getPlayerUrlById(player?.id);
    return (
      <div className={`match-formation__item ${homeTeam ? '' : 'flipped'}`}>
        <div className="player-bust">
          <div className="player-bust__images player-bust__images--formation">
            <img
              className="player-bust__player-image"
              src={getProxyUrl(player?.image, 200, 200)}
              alt=""
            />
          </div>
          <a
            style={{ pointerEvents: playerUrl ? 'auto' : 'none' }}
            href={playerUrl || ''}
            className="player-bust__info player-bust__info--formation text-decoration-none"
          >
            <div className="player-bust__number player-bust__number--formation fw-bold">
              {player?.shirtNumber}
            </div>
            <div className="player-bust__name player-bust__name--formation d-flex flex-column justify-content-center">
              <div className="player-bust__first-name--formation fw-bold text-transform-none d-none d-lg-block">
                {player?.givenName}
              </div>
              <div className="player-bust__last-name--formation text-transform-none d-flex fw-bold">
                <span className="d-inline-block d-lg-none me-1">
                  {player?.givenName[0]}.
                </span>
                {player?.surName}
              </div>
            </div>
            <div className="player-bust__events">
              {player?.hasBeenSubstituted && (
                <div className="d-flex flex-column">
                  <svg
                    className="arrow--left arrow--red"
                    width="8"
                    height="8"
                    viewBox="0 0 11 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                      fill="currentColor"
                    />
                  </svg>
                  <svg
                    className="arrow--right arrow--green"
                    width="8"
                    height="8"
                    viewBox="0 0 11 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              )}
              {player.hasScored > 0 &&
                [...Array(player.hasScored)].map((a, index) => (
                  <object
                    key={`${player.id}-goal-${index.toString()}`}
                    width="17"
                    height="17"
                    data="/wp-content/themes/sef-leagues/images/football-logo.svg"
                    type="image/svg+xml"
                  />
                ))}
              {player.hasWarning && <div className="yellow-card" />}
              {player.hasRedCard && <div className="red-card" />}
            </div>
          </a>
        </div>
      </div>
    );
  };
  const renderSubPlayer = (player) => {
    const playerUrl = getPlayerUrlById(player?.fogisId);

    return (
      <div className="data-container__row px-4 py-1 d-flex align-items-center">
        <a
          style={{ pointerEvents: playerUrl ? 'auto' : 'none' }}
          href={playerUrl || ''}
          className="d-flex align-items-center text-decoration-none text-color-primary-white"
        >
          <div className="player-bust__number player-bust__number--lineup fw-bold">
            {player?.shirtNumber}
          </div>
          <div className="player-bust__name player-bust__name--lineup d-flex fw-bold">
            {player?.displayName}
          </div>
        </a>
        <div className="d-flex gap-2 ms-auto align-items-center">
          {player.hasBeenSubstituted && (
            <div className="d-flex flex-column">
              <svg
                className="arrow--left arrow--red"
                width="11"
                height="13"
                viewBox="0 0 11 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                  fill="currentColor"
                />
              </svg>
              <svg
                className="arrow--right arrow--green"
                width="11"
                height="13"
                viewBox="0 0 11 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          )}
          {player.hasScored &&
            [...Array(player.hasScored)].map((a, index) => (
              <object
                key={`${player.id}-goal-${index.toString()}`}
                width="17"
                height="17"
                data="/wp-content/themes/sef-leagues/images/football-logo.svg"
                type="image/svg+xml"
              />
            ))}
          {player.hasWarning && <div className="yellow-card" />}
          {player.hasRedCard && <div className="red-card" />}
        </div>
      </div>
    );
  };

  if (lineups && !lineupsLoading) {
    return (
      <section className="row mt-5">
        <div className="col-12 col-lg-7">
          <h3 className="heading-h3 d-none d-lg-block">STARTELVA - {team}</h3>
          <p className="text-small fw-bold text-color-primary-yellow">
            {lineup?.formation}
          </p>
          <div
            className={`match-formation match-formation--formation-${
              lineup?.formation
            } ${homeTeam ? '' : 'flipped'}`}
          >
            {_.orderBy(
              (lineup?.starting ?? []).map((l) => ({
                ...l,
                positionIndexFromBackRight: parseInt(
                  l.positionIndexFromBackRight,
                  10
                ),
                position: parseInt(l.position, 10),
              })),
              ['positionIndexFromBackRight', 'position'],
              ['asc', 'asc']
            ).map((p) => renderFormationPlayer(p))}
          </div>
        </div>
        <div className="col-12 col-lg mt-4 mt-lg-0">
          <div className="data-container">
            <div className="data-container__row data-container__header px-4 py-3">
              <span className="heading-h5 text-transform-none">Ersättare</span>
            </div>
            {lineup?.substitutes?.map((p) => renderSubPlayer(p))}
          </div>
        </div>
      </section>
    );
  }
  if (lineupsLoading) return <Loader />;
}

export default Formation;
